import { render, staticRenderFns } from "./hr_user_edit.vue?vue&type=template&id=6a99bf9d&scoped=true&"
import script from "./hr_user_edit.vue?vue&type=script&lang=js&"
export * from "./hr_user_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a99bf9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a99bf9d')) {
      api.createRecord('6a99bf9d', component.options)
    } else {
      api.reload('6a99bf9d', component.options)
    }
    module.hot.accept("./hr_user_edit.vue?vue&type=template&id=6a99bf9d&scoped=true&", function () {
      api.rerender('6a99bf9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/hr/add/hr_user_edit.vue"
export default component.exports